export type InspectionSelection = {
  readonly inspectionType: string;
  readonly recordId: number | string | null;
};

export function inspectionSelectionKey(
  inspectionType: string,
): string {
  return inspectionType.toLowerCase().replace(/\s/g, '-');
}

interface InspectionIndexTarget {
  readonly id: number | string;
  readonly inspectionType: string;
  readonly inspectionDate: string;
}

export function findInspectionTimelineIndex(
  inspections: readonly InspectionIndexTarget[],
  selection: InspectionSelection,
): number {
  if (selection.recordId != null) {
    const byId = inspections.findIndex(
      (item) => String(item.id) === String(selection.recordId),
    );
    if (byId >= 0) {
      return byId;
    }
  }

  const normalizedType = selection.inspectionType.toLowerCase();
  for (let index = inspections.length - 1; index >= 0; index -= 1) {
    if (inspections[index].inspectionType.toLowerCase() === normalizedType) {
      return index;
    }
  }

  return -1;
}
